import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const FAQ_ITEMS = [
  {
    q: 'QR 코드 스캔이 안 돼요',
    a: '스마트폰의 카메라 앱을 실행한 뒤 테이블 QR 코드에 초점을 맞추어 주세요. 인식이 어려운 경우 화면을 QR 코드에 가까이 대거나 조명을 밝게 해 보세요. 그래도 스캔이 되지 않는 경우 직원 호출 기능을 이용하시거나 직원에게 도움을 요청해 주세요.',
  },
  {
    q: '결제 중 오류가 발생했어요',
    a: '일시적인 네트워크 오류가 원인인 경우가 많습니다. 결제 창을 닫고 다시 시도해 주시고, 중복 결제가 발생한 것 같다면 고객센터 또는 매장 직원에게 즉시 문의하시면 확인 후 조치해 드립니다. 카드사 승인이 거절된 경우 해당 카드사로 직접 문의해 주세요.',
  },
  {
    q: '환불은 어떻게 요청하나요?',
    a: '주문 상세 화면의 "환불 요청" 버튼을 통해 신청하시거나, 매장 직원에게 직접 요청해 주세요. 조리가 시작되기 전에는 전액 환불이 가능하며, 이후에는 매장 귀책사유에 한하여 환불이 진행됩니다. 자세한 내용은 환불정책 페이지를 참고해 주세요.',
  },
  {
    q: '영수증은 어디서 발급할 수 있나요?',
    a: '주문 완료 화면과 주문 내역에서 전자 영수증을 확인하실 수 있습니다. 현금영수증이 필요하신 경우 결제 전에 "현금영수증 발급"을 선택하시거나 매장 직원에게 요청해 주세요.',
  },
  {
    q: '직원을 부르고 싶어요',
    a: '화면 우측 하단의 종 모양 아이콘을 누르시면 직원 호출 화면이 나타납니다. 호출 사유(물, 수저, 기타 요청 등)를 선택한 뒤 전송하시면 매장에 즉시 알림이 전달됩니다. 짧은 시간 동안 중복 호출은 제한될 수 있습니다.',
  },
  {
    q: '주문한 메뉴를 변경하고 싶어요',
    a: '주문 전이라면 장바구니에서 언제든지 수량과 옵션을 변경하실 수 있습니다. 이미 주문을 전송하셨다면 조리가 시작되기 전에 한해 변경이 가능하므로, 직원 호출 또는 직접 직원에게 요청해 주세요.',
  },
  {
    q: '주문을 취소하고 싶어요',
    a: '주문 전송 이후에는 매장의 수락 여부에 따라 취소 가능 여부가 결정됩니다. 조리가 시작되기 전까지는 취소가 가능합니다. 취소 요청은 주문 상세 화면 또는 직원 호출을 이용해 주세요.',
  },
  {
    q: '자리를 이동해도 되나요?',
    a: '자리 이동이 필요하신 경우 직원 호출을 통해 요청해 주세요. 새 테이블의 QR 코드를 다시 스캔하시면 해당 테이블에서 주문을 이어갈 수 있습니다. 기존 주문 내역은 매장에 그대로 전달됩니다.',
  },
  {
    q: '비밀번호 등 개인정보가 걱정돼요',
    a: '스마트오더는 고객 로그인을 요구하지 않으며, 필요한 최소한의 정보만 암호화 통신(HTTPS)으로 전송됩니다. 결제 정보는 자격 인증된 전자지급결제대행업체(PortOne 등)를 통해 처리되며, 회사의 서버에는 저장되지 않습니다.',
  },
  {
    q: '데이터 보안은 어떻게 관리되나요?',
    a: '모든 데이터 전송은 TLS 1.2 이상의 보안 프로토콜로 암호화됩니다. 결제 데이터는 PCI-DSS 인증을 받은 결제 대행사를 통해 처리되며, 회사는 개인정보보호법 및 정보통신망법에 따라 접근 통제, 암호화, 로그 기록 등의 보호조치를 시행하고 있습니다.',
  },
];

const CATEGORIES = ['주문/결제', '환불/취소', '계정/개인정보', '기술 문의', '기타'];

export default function SupportPage() {
  const navigate = useNavigate();
  const [openIdx, setOpenIdx] = useState(-1);
  const [form, setForm] = useState({ name: '', email: '', category: CATEGORIES[0], message: '' });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (key) => (e) => {
    setForm({ ...form, [key]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setError('이름, 이메일, 문의 내용을 모두 입력해 주세요.');
      return;
    }
    if (!/^\S+@\S+\.\S+$/.test(form.email)) {
      setError('올바른 이메일 주소를 입력해 주세요.');
      return;
    }
    setSubmitting(true);
    try {
      // Placeholder submission - integrate with real endpoint later.
      await new Promise((r) => setTimeout(r, 600));
      setSubmitted(true);
      setForm({ name: '', email: '', category: CATEGORIES[0], message: '' });
    } catch (err) {
      setError('문의 접수에 실패했습니다. 잠시 후 다시 시도해 주세요.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="page" style={{ background: 'var(--bg)', paddingBottom: 'calc(40px + var(--safe-bottom))' }}>
      <header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 100,
          background: 'var(--surface)',
          borderBottom: '1px solid var(--border)',
          padding: 'calc(var(--safe-top) + 14px) 20px 14px',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          minHeight: 56,
        }}
      >
        <button className="back-btn" onClick={() => navigate(-1)} aria-label="뒤로 가기">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div className="page-header-title">고객 지원</div>
        <div style={{ width: 36 }} />
      </header>

      <main style={{ padding: '24px 20px 40px', maxWidth: 480, margin: '0 auto' }}>
        <div style={{ marginBottom: 24 }}>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: 'var(--text)', letterSpacing: '-0.5px', marginBottom: 6 }}>
            무엇을 도와드릴까요?
          </h1>
          <p style={{ fontSize: 14, color: 'var(--text-tertiary)' }}>
            자주 묻는 질문을 먼저 확인해 보시고, 해결되지 않는 경우 1:1 문의를 남겨 주세요.
          </p>
        </div>

        {/* Contact info */}
        <div
          style={{
            background: 'var(--primary-light)',
            borderRadius: 16,
            padding: 16,
            marginBottom: 24,
            display: 'flex',
            gap: 16,
            alignItems: 'center',
          }}
        >
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: 12,
              background: 'var(--primary)',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
          </div>
          <div style={{ flex: 1, fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            <div style={{ fontWeight: 700, color: 'var(--text)', marginBottom: 2 }}>고객센터</div>
            <div>전화: 1588-0000 (평일 10:00~18:00)</div>
            <div>이메일: support@smartorder.example</div>
          </div>
        </div>

        {/* FAQ */}
        <h2 style={{ fontSize: 16, fontWeight: 700, color: 'var(--text)', marginBottom: 10 }}>자주 묻는 질문</h2>
        <div style={{ marginBottom: 32 }}>
          {FAQ_ITEMS.map((item, idx) => {
            const open = openIdx === idx;
            return (
              <div
                key={idx}
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--border)',
                  borderRadius: 12,
                  marginBottom: 8,
                  overflow: 'hidden',
                }}
              >
                <button
                  type="button"
                  aria-expanded={open}
                  onClick={() => setOpenIdx(open ? -1 : idx)}
                  style={{
                    width: '100%',
                    background: 'transparent',
                    border: 'none',
                    padding: '14px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 12,
                    textAlign: 'left',
                    cursor: 'pointer',
                    color: 'var(--text)',
                    fontSize: 14,
                    fontWeight: 600,
                    letterSpacing: '-0.3px',
                  }}
                >
                  <span style={{ flex: 1 }}>{item.q}</span>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="var(--text-tertiary)"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{
                      transition: 'transform 0.2s ease',
                      transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                      flexShrink: 0,
                    }}
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>
                {open && (
                  <div
                    style={{
                      padding: '0 16px 14px',
                      fontSize: 13,
                      color: 'var(--text-secondary)',
                      lineHeight: 1.75,
                    }}
                  >
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* 1:1 inquiry form */}
        <h2 style={{ fontSize: 16, fontWeight: 700, color: 'var(--text)', marginBottom: 10 }}>1:1 문의하기</h2>

        {submitted ? (
          <div
            style={{
              background: 'var(--success-light)',
              borderRadius: 12,
              padding: 20,
              textAlign: 'center',
              color: 'var(--success)',
            }}
          >
            <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 4 }}>문의가 접수되었습니다</div>
            <div style={{ fontSize: 13 }}>영업일 기준 1~2일 이내에 답변드리겠습니다.</div>
            <button
              type="button"
              onClick={() => setSubmitted(false)}
              style={{
                marginTop: 12,
                padding: '8px 16px',
                background: 'transparent',
                border: '1px solid var(--success)',
                color: 'var(--success)',
                borderRadius: 8,
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              다른 문의 남기기
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            <div style={{ marginBottom: 12 }}>
              <label style={labelStyle}>이름</label>
              <input
                type="text"
                value={form.name}
                onChange={handleChange('name')}
                placeholder="이름을 입력해 주세요"
                aria-label="이름"
                style={inputStyle}
              />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={labelStyle}>이메일</label>
              <input
                type="email"
                value={form.email}
                onChange={handleChange('email')}
                placeholder="답변받을 이메일 주소"
                aria-label="이메일"
                style={inputStyle}
              />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={labelStyle}>문의 유형</label>
              <select
                value={form.category}
                onChange={handleChange('category')}
                aria-label="문의 유형"
                style={{ ...inputStyle, appearance: 'none' }}
              >
                {CATEGORIES.map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>문의 내용</label>
              <textarea
                value={form.message}
                onChange={handleChange('message')}
                placeholder="문의하실 내용을 자세히 적어 주세요"
                aria-label="문의 내용"
                rows={6}
                style={{ ...inputStyle, resize: 'vertical', minHeight: 120, fontFamily: 'inherit' }}
              />
            </div>

            {error && (
              <div
                style={{
                  background: 'var(--danger-light)',
                  color: 'var(--danger)',
                  padding: '10px 14px',
                  borderRadius: 10,
                  fontSize: 13,
                  marginBottom: 12,
                }}
              >
                {error}
              </div>
            )}

            <button
              type="submit"
              className="btn btn-primary btn-block btn-lg"
              disabled={submitting}
            >
              {submitting ? '전송 중...' : '문의 보내기'}
            </button>
          </form>
        )}
      </main>
    </div>
  );
}

const labelStyle = {
  display: 'block',
  fontSize: 13,
  fontWeight: 600,
  color: 'var(--text-secondary)',
  marginBottom: 6,
};

const inputStyle = {
  width: '100%',
  padding: '14px 16px',
  background: 'var(--border)',
  border: 'none',
  borderRadius: 12,
  fontSize: 15,
  color: 'var(--text)',
  outline: 'none',
  fontFamily: 'inherit',
};
